import React from "react";
import "../../css/SchoolHero.css";
import SliderTabs from "../SliderTabs";

const SchoolHero = ({ title, subtitle, image }) => {
  return (
    <section
      className="school-hero"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,.55), rgba(0,0,0,.55)), url(${image})`,
      }}
    >
      <div className="school-hero-content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
      <div className="hero-slider-tabs">
         <SliderTabs />
      </div>
     
    </section>
  );
};

export default SchoolHero;
